import { render, staticRenderFns } from "./Chestionar.vue?vue&type=template&id=21ba342d&"
import script from "./Chestionar.vue?vue&type=script&lang=js&"
export * from "./Chestionar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports